<template>
  <div  class="switch-lang">
    <div @click="switchLang(lang !== 'Inuktitut')" :class="{ off: lang !== 'Inuktitut' }" class="lang-label">ᐃᓄᒃᑎᑐᑦ</div>
    <img class="chapter" src="@/assets/images/chapter.svg"/>
    <div @click="switchLang(lang !== 'English')" :class="{ off: lang !== 'English' }" class="lang-label">English</div>
  </div>
</template>

<script>
export default {
  computed: {
    lang () {
      return this.$store.state.lang
    }
  },
  methods: {
    switchLang (switchable) {
      if (switchable) {
        // document.querySelector('.events').style.scrollBehavior = 'auto'
        const newLang = this.lang === 'English' ? 'Inuktitut' : 'English'
        this.$store.commit('setEventId', 'introduction')
        this.$store.commit('setLang', newLang)
        const locale = newLang === 'English' ? 'en' : 'iu'
        this.$i18n.locale = locale
        window.localStorage.setItem('lang', newLang)
        // window.location.href = '#introduction'
        // window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
  .switch-lang {
    pointer-events: auto;
    margin-right: 24px;
    // // position: absolute;
    // right: 300px;
    // bottom: 64px;
    display: flex;
    font-family: Georgia;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #18333c;
    cursor: auto;
    .chapter {
      height: 16px;
      width: 16px;
    }
    .off {
      color: #7d939a;
      cursor: pointer;
    }
  }
</style>
